import Dayjs from './dayjs';

export default class Now extends Dayjs {}
